import { useEffect, useRef, useState } from 'react'
import {
  SAside,
  SDrawerOrModal,
  SLowcodeList,
  SSkuCard,
  STableActions,
  SActionBtn,
  STags,
  SMessage,
} from 'shj-components'
// import { config } from './config'
import styles from '../../index.module.less'
import {
  getBrandList,
  importSkuInfo,
  getProductCategoryTreeList,
  getProductEnums,
  getSkuList,
  getSpecialCodesList,
  getSkuAllowCompanies,
  getAuthSkuList,
  batchUpdateProductSkuEnabled,
  getGeneralList,
  getProductCommonPage,
  generalStandardBatchAdd,
  findSpuFormatPage,
  findSpuModelPage,
  productSkuDetail,
} from '@/services/product'
import { getAllCompany, httpOrgList } from '@/services/homeService.ts'
import { useNavigate } from 'react-router-dom'
import { apiData2Table } from '@/utils/data'
import { getBizOpTypeEnum } from '@/services/customerServices'
import { useSetState,useUpdateEffect } from 'ahooks'
import ProductDetailDrawerSpuSku from '@/components/ProductDetailDrawerSpuSku'
import { Form, Input, Upload, Button, Tooltip, message, InputNumber } from 'antd'
import { UploadOutlined, DownloadOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { fileDownload } from '@/utils/download.ts'
import UrlConfig from '@/api/UrlConfigs.ts'
import NotCombinatePriceModal from './components/notCombinatePriceModal'
import CombinatePriceModal from './components/combinatePriceModal'
import DebounceSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import _ from 'lodash'
import { AddOrEditStandard } from './components/addToGeneral'

export default function TreeSearchTable() {
  const listRef = useRef<any>(null)
  const navigate = useNavigate()
  const [prodCateIds, setProdCateIds] = useState<any>([])
  const [treeData, setTreeData] = useState<any>([])
  const [importLoading, setImportLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)
  const [openNotComPriceModal, setOpenNotComPriceModal] = useState(false)
  const [openComPriceModal, setOpenComPriceModal] = useState(false)
  const [orgList, setOrgList] = useState<any>([])
  const [chooseSkuId, setChooseSkuId] = useState('')
  const [chooseDiabled, setChooseDisabled] = useState(false)
  const [dataList, setDataList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [config, setConfig] = useState<any>({
    rowSelection: true,
    columns: [
      {
        title: 'SKU名称',
        dataIndex: 'skuName',
        width: 650,
        name: 'skuName',
        render: 'renderProduct',
      },
          {
        title: '上架产品',
        dataIndex: 'inStoreProducts',
        name: 'inStoreProducts',
        width: 400,
        // ellipsis: {
        //   showTitle: false,
        // },
        render: val => <span>{val?.map(item => item.productName)?.join('，') || ''}</span>,
      },
      {
        title: '标配上架门店',
        dataIndex: 'generalStandardInStoreShops',
        name: 'generalStandardInStoreShops',
        width: 400,
        render: val => <span>{val?.map(item => item.name)?.join('，') || ''}</span>,
      },
      {
        title: '产品类型',
        dataIndex: 'prodTypeName',
        name: 'prodTypeName',
        width: 100,
      },
      {
       title: ( <div>
            <span>适用门店</span>
            <Tooltip title="SKU的当前可销售门店（不包含已经缺断货的门店）">
              <span
                style={{
                  height: '18px',
                  width: '18px',
                  color: '#000',
                  marginLeft: '5px',
                  cursor: 'pointer',
                }}
              >
                <QuestionCircleOutlined style={{ height: '18px', width: '18px', color: '#000' }} />
              </span>
            </Tooltip>
          </div>),
        dataIndex: 'shops',
        width: 220,
        name: 'shops',
        render: val => <span>{val?.map(item => item.companyName)?.join('，') || ''}</span>,
        ellipsis: {
          showTitle: true,
        },
      },
       {
       title: ( <div>
            <span>服务门店</span>
            <Tooltip title="SKU的历史可供门店（包含已经缺断货的门店）">
              <span
                style={{
                  height: '18px',
                  width: '18px',
                  color: '#000',
                  marginLeft: '5px',
                  cursor: 'pointer',
                }}
              >
                <QuestionCircleOutlined style={{ height: '18px', width: '18px', color: '#000' }} />
              </span>
            </Tooltip>
          </div>),
        dataIndex: 'serviceShops',
        width: 220,
        name: 'serviceShops',
        render: val => <span>{val?.map(item => item.companyName)?.join('，') || ''}</span>,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: '关联SPU编码',
        dataIndex: 'productId',
        width: 250,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        title: '需求标签',
        dataIndex: 'bizTagName',
        width: 120,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        title: '产品分类',
        dataIndex: 'prodCateName',
        width: 120,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        title: '品牌',
        dataIndex: 'brandName',
        width: 150,
        ellipsis: {
          showTitle: false,
        },
      },

      {
        title: '单位',
        dataIndex: ['unitInfo', 'unitName'],
        width: 80,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        title: '特项代码',
        dataIndex: 'specialCode',
        name: 'specialCode',
        width: 100,
      },
      {
        title: '来源',
        dataIndex: 'sourceTypeName',
        name: 'sourceTypeName',
        width: 100,
      },
      {
        title: '物料/施工SKU编码',
        dataIndex: 'sourceCode',
        name: 'sourceCode',
        width: 200,
      },
      {
        title: '型号',
        dataIndex: ['materialInfo', 'model'],
        name: ['materialInfo', 'model'],
        width: 100,
      },
      {
        title: '规格',
        dataIndex: ['materialInfo', 'format'],
        name: ['materialInfo', 'format'],
        width: 100,
      },
      {
        title: '渠道价',
        dataIndex: 'materialChannelPrice',
        name: 'materialChannelPrice',
        width: 100,
        auth: 'showMaterialChannelPrice',
      },
      {
        title: '关联组合SKU_ID',
        dataIndex: 'groupRefs',
        name: 'groupRefs',
        width: 300,
        ellipsis: {
          showTitle: false,
        },
        render: val => <span>{val?.map(item => item.groupSkuId)?.join('，') || ''}</span>,
      },
      {
        title: '上架通项',
        dataIndex: 'inStoreGeneralItems',
        name: 'inStoreGeneralItems',
        width: 100,
        render: val => <span>{val?.map(item => item.name)?.join('，') || ''}</span>,
      },
      {
        title: '创建时间',
        dataIndex: 'createdTime',
        name: 'createdTime',
        width: 250,
        itemType: 'dateTime',
        ellipsis: {
          showTitle: false,
        },
      },
      {
        title: (
          <div>
            <span>有效状态</span>
            <Tooltip title="SKU无效原因可能有：供应链物料下架或删除">
              <span
                style={{
                  height: '18px',
                  width: '18px',
                  color: '#000',
                  marginLeft: '5px',
                  cursor: 'pointer',
                }}
              >
                <QuestionCircleOutlined style={{ height: '18px', width: '18px', color: '#000' }} />
              </span>
            </Tooltip>
          </div>
        ),
        dataIndex: 'effective',
        name: 'effective',
        width: 120,
        render: text => <span>{text ? '有效' : '无效'}</span>,
      },
      {
        title: 'SKU状态',
        dataIndex: 'enabledName',
        name: 'enabledName',
        width: 90,
        fixed: 'right',
        render: 'enableRender',
      },
      {
        title: '操作',
        dataIndex: '#',
        width: 140,
        fixed: 'right',
        render: 'actionRender',
      },
    ],
    search: [
      {
        label: 'SKU名称',
        name: 'skuNameKeyword',
      },
      {
        label: 'SKU_ID',
        name: 'id',
      },
      {
        label: 'SPU_ID',
        name: 'productId',
      },
      {
        label: '物料/施工SKU编码',
        name: 'sourceCode',
      },
      {
        label: '适用门店',
        name: 'shopIds',
        itemType: 'select',
        key: 'id',
        labelKey: 'companyName',
        data: 'companyList',
        events: ['onChange:onCompanyCodeChange'],
      },
      {
        label: '渠道价范围',
        itemType: 'custom',
        render: 'priceRangeRender',
        hidden: true,
      },
      {
        label: '',
        name: 'channelPriceStartWith',
        hidden: true,
      },
      {
        label: '',
        name: 'channelPriceEndWith',
        hidden: true,
      },
      {
        label: '产品类型',
        name: 'prodType',
        itemType: 'select',
        data: 'productTypeList',
        key: 'value',
        labelKey: 'label',
      },
      {
        label: '需求标签',
        name: 'bizTag',
        itemType: 'select',
        data: 'demandList',
        key: 'value',
        labelKey: 'label',
      },
      {
        label: '品牌',
        itemType: 'select',
        data: 'brandList',
        name: 'brandId',
        key: 'value',
        labelKey: 'label',
      },
      {
        label: '型号',
        itemType: 'custom',
        name: 'modelKeyword',
        render: 'modelRender',
      },
      {
        label: '规格',
        itemType: 'custom',
        name: 'formatKeyword',
        render: 'formatRender',
      },
      {
        label: '产品状态',
        itemType: 'select',
        name: 'enabled',
        key: 'value',
        labelKey: 'label',
        data: [
          { label: '启用', value: true },
          { label: '停用', value: false },
        ],
      },
      {
        label: '特项代码',
        name: 'specialCode',
        itemType: 'select',
        data: 'specialCodeList',
        labelKey: 'showName',
        key: 'code',
      },
      {
        label: '上架通项',
        itemType: 'select',
        data: 'generalList',
        name: 'inStoreGeneralItemId',
        key: 'id',
        labelKey: 'itemName',
      },
      {
        label: '上架产品',
        itemType: 'custom',
        name: 'inStoreProductId',
        render: 'productRender',
      },
      {
        label: '标配上架门店',
        itemType: 'select',
        data: 'allCompanyList',
        name: 'generalStandardInStoreShopId',
        key: 'id',
        labelKey: 'name',
      },
    ],
    footer: [
      { label: '下载模板', render: 'exportRender' },
      { label: '导入产品', render: 'importRender', auth: 'skuBatchImport' },
      { label: '导出', render: 'exportDataRender', auth: 'skuBatchExport' },
      {
        label: '列表数据全选',
        type: 'primary',
        ghost: true,
        auth: 'skuAllSelect',
        events: ['onClick:allSelect'],
      },
      // { label: '添加到通项标配', render: 'addToStandardRender' },
    ],
    batchActions: [
      {
        label: '批量启用',
        danger: true,
        ghost: true,
        auth: 'skuBatchEnable',
        events: ['onClick:batchEnable'],
      },
      {
        label: '批量禁用',
        danger: true,
        ghost: true,
        auth: 'skuBatchDisable',
        events: ['onClick:batchDisable'],
      },
      {
        label: '添加到通项标配',
        danger: true,
        ghost: true,
        auth: 'skuAddToStandard',
        events: ['onClick:AddToStandard'],
      },
    ],
  })
  const [searchParams, setSearchParams] = useState<any>({})
  const [generalStandardOpen, setGeneralStandardOpen] = useState(false)
  const [generalStandardLoading, setGeneralStandardLoading] = useState(false)
  const [minPrice, setMinPrice] = useState(0)
  
  const [skuSourceType, setSkuSourceType] = useState('')
  const editRef = useRef()
  const [previewObj, setPreviewObj] = useSetState<any>({
    open: false,
    loading: false,
    descType: [],
    data: {},
  })
  useEffect(() => {
    getTreeData()
  }, [])
  const getTreeData = () => {
    getProductCategoryTreeList({}).then((res: any) => {
      setTreeData([{ cateName: '不限', id: '0' }, ...res])
    })
  }
  useUpdateEffect(() => {
    listRef.current?.reload()
  }, [prodCateIds])
  //   左侧树节点事件
  const onChangeType = (_: any, info) => {
    console.log(info)
    setProdCateIds([])
    if (info.selected) {
      setProdCateIds(prevIds => [...prevIds, info.node.id])
      findAllChildsId(info.node)
    }
  }
  const findAllChildsId = (node: any) => {
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => {
        setProdCateIds(prevIds => [...prevIds, child.id])
        findAllChildsId(child)
      })
    }
  }
  // 监听适用门店是否有值
  const onCompanyCodeChange = (value: any) => {
    let newConfig: any = _.cloneDeep(config)
    newConfig.search.find((item: any) => item.label === '渠道价范围').hidden = !value
    setConfig(newConfig)
  }

  const onImport = async (upload: any) => {
    setImportLoading(true)
    const { file, onSuccess } = upload
    const data = new FormData()
    data.append('file', file)
    try {
      const res: any = await importSkuInfo(data)
      listRef.current && listRef.current.reload()
      onSuccess && onSuccess()
      if (res?.length) {
        let str = ''
        res.forEach((item, index) => {
          if (item?.errorMessages?.length) {
            str =
              str +
              ' ' +
              `第${item.lineNumber}行` +
              '、' +
              item?.errorMessages.join('、')?.slice(0, 100)
          }
        })
        str = str?.slice(0, 300)
        if (str !== '') {
          message.error(str)
        } else {
          message.success(res.message || '导入成功')
        }
      } else {
        message.success(res.message || '导入成功')
      }
      setImportLoading(false)
    } catch (err) {
      setImportLoading(false)
      console.log(err)
    }
  }

  const onExport = async () => {
    try {
      setExportLoading(true)
      await fileDownload(UrlConfig.PlusProductWeb.DownloadSkuInfo)
      setExportLoading(false)
    } catch (err) {
      setExportLoading(false)
      console.log(err)
    }
  }
  const onExportData = async () => {
    let searchValue = { ...searchParams }
    try {
      setExportLoading(true)
      await fileDownload(UrlConfig.PlusProductWeb.SkuDetailsExport, {
        method: 'POST',
        data: searchValue || {},
      })
      setExportLoading(false)
    } catch (err) {
      setExportLoading(false)
      console.log(err)
    }
  }

  //   右侧数据查询
  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    rest.query.modeFlags = [1, 2]
    if (!prodCateIds || prodCateIds[0] == '0') {
      rest.query.prodCateIds = []
    } else {
      rest.query.prodCateIds = prodCateIds
    }
    rest.query = {
      ...rest.query,
      queryMaterialInfo: true, //是否查询物料信息
      queryMaterialChannelPrice: true, //是否查询物料采购价
      queryInStoreGeneralItem: true, //是否查询上架通项
      queryInStoreProduct: true, //是否查询上架产品
      queryGeneralStandardInStoreShop: true, //是否查询标配上架门店
      materialFilter: {
        modelKeyword: rest.query.modelKeyword, //型号关键字
        formatKeyword: rest.query.formatKeyword, //规格关键字
        channelPriceStartWith: rest.query.channelPriceStartWith, //渠道价范围-开始
        channelPriceEndWith: rest.query.channelPriceEndWith, //渠道价范围-结束
        channelPriceQueryShopId: rest.query.shopIds, //渠道价查询门店ID
      },
      shopIds: rest.query?.shopIds ? [rest.query?.shopIds] : null,
      queryShops: true,
      queryGroupRef: true, //是否查询关联组合信息
    }
    console.log(rest.query, '查询参数')
    setSearchParams({ ...rest.query })
    return new Promise((resolve, reject) => {
      try {
        getAuthSkuList({
          params: { pageId: current, pageSize },
          data: {
            ...rest.query,
          },
        }).then(data => {
          console.log(data)
          setDataList(data?.list || [])
          setTotalCount(data?.count)
          resolve(apiData2Table(data as { total: number; records: any[] }))
        })
      } catch (err) {
        reject({ success: false })
      }
    })
  }
  //   下拉选项加载
  const getOptions = async () => {
    return new Promise(resolve => {
      Promise.all([
        getProductEnums('com.shj.saas.plus.product.enums.ProductTypeEnum'),
        getBizOpTypeEnum(),
        getBrandList({}),
        getSpecialCodesList({ data: {} }),
        getAllCompany(),
        getGeneralList({}),
        httpOrgList(),
      ]).then((res: any) => {
        const obj = {
          productTypeList: res[0].map((item: any) => {
            return { label: item.description, value: item.key }
          }),
          demandList: res[1].map((item: any) => {
            return { label: item.description, value: item.key }
          }),
          brandList: res[2]?.map((item: any) => {
            return { label: item.name, value: item.id }
          }),
          specialCodeList: res[3],
          companyList: res[4],
          generalList: res[5],
          allCompanyList: res[6],
        }
        // setState({ ...state, ...obj })
        resolve({ ...obj })
      })
    })
  }

  // 新增产品
  const onAdd = () => {
    navigate(`/config/productManage/productSteps`)
  }

  const handleSearchPrice = async (item: any) => {
    const res = await getSkuAllowCompanies(item.id)
    if (Array.isArray(res)) {
      setOrgList(res || [])
    } else {
      setOrgList([])
    }
    if (item.prodType === 'PRODUCT_GROUP') {
      setChooseSkuId(item.id)
      setOpenComPriceModal(true)
    } else {
      setSkuSourceType(item.sourceType)
      setChooseSkuId(item.id)
      setOpenNotComPriceModal(true)
    }
  }
  const batchEnable = ({ selectedRowKeys, selectedRows }: any) => {
    SMessage.confirm({
      onOk: () => {
        return batchUpdateProductSkuEnabled({
          enabled: true,
          skuQuery: {
            ...searchParams,
            ids: chooseDiabled ? [] : selectedRowKeys, //id列表
          },
        })
          .then(() => {
            listRef.current?.reload()
          })
          .finally(() => {
            setChooseDisabled(false)
          })
      },
      title: `确定启用这些产品吗？`,
      content: null,
    })
  }
  const batchDisable = ({ selectedRowKeys, selectedRows }: any) => {
    SMessage.confirm({
      onOk: () => {
        return batchUpdateProductSkuEnabled({
          skuQuery: {
            ...searchParams,
            ids: chooseDiabled ? [] : selectedRowKeys, //id列表
          },
          enabled: false,
        })
          .then(() => {
            listRef.current?.reload()
          })
          .finally(() => {
            setChooseDisabled(false)
          })
      },
      title: `确定禁用这些产品吗？`,
      content: null,
    })
  }
  const allSelect = () => {
    if (chooseDiabled) {
      setChooseDisabled(false)
      listRef?.current?.clearSelectedRowKeys()
    } else {
      setChooseDisabled(true)
      const ids: any = dataList?.map((item: any) => item.id)
      setSelectedRowKeys(ids)
    }
  }
  const AddToStandard = ({ selectedRowKeys, selectedRows }: any) => {
    console.log(selectedRowKeys, selectedRows)
    setGeneralStandardOpen(true)
  }
  const onSearchReset = () => {
    listRef?.current?.getSearch().setFieldsValue({ ['channelPriceStartWith']: undefined })
    listRef?.current?.getSearch().setFieldsValue({ ['channelPriceEndWith']: undefined })
    let newConfig: any = _.cloneDeep(config)
    newConfig.search.find((item: any) => item.label === '渠道价范围').hidden = true
    setConfig(newConfig)
  }
  const onOpenProductDetail = (record:any)=>{
    console.log(record)
    setPreviewObj({ open: true, loading: true })
    productSkuDetail(record?.id).then((res:any)=>{
      console.log(res)
      res.name = 'SKU名称'     
      res.prodName = res?.skuName;
      setPreviewObj({
          data: res,
      })
    }).finally(() => setPreviewObj({ loading: false }))
  }
  const extensions = {
    onSearchReset,
    request: { fetchList, getOptions },
    events: {
      onAdd,
      batchEnable,
      batchDisable,
      allSelect,
      AddToStandard,
      onCompanyCodeChange,
    },
    getCheckboxProps: record => ({
      disabled: chooseDiabled,
    }),
    selectedRowKeys: selectedRowKeys,
    onSelectedRowChange: (keys, rows) => {
      setSelectedRowKeys(keys)
    },
    status: {
      selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
      // exportLoading: state.exportLoading,
    },
    customRender: {
      renderProduct(_, record: Record<string, any>) {
        return (
          <SSkuCard
            width={'100%'}
            url={record.mainPicUrl || ''}
            desc={record.id}
            operation={() => {
              return <div></div>
            }}
            title={
              <Tooltip title={record.skuName}>
                <a className={styles.showTwoLinehidden} onClick={() => onOpenProductDetail(record)}>{record.skuName}</a>
              </Tooltip>
            }
          ></SSkuCard>
        )
      },
      enableRender(_, record: Record<string, any>) {
        return (
          <STags
            itemKey=""
            label={record.enabled ? '启用' : '禁用'}
            fontColor={record.enabled ? '#00A865' : '#EB3723'}
            bgColor={record.enabled ? '#D7F7EA' : '#FFEAE8'}
          />
        )
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={importLoading}
              disabled={importLoading}
              icon={<UploadOutlined />}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            icon={<DownloadOutlined />}
            onClick={onExport}
            disabled={exportLoading}
            loading={exportLoading}
            type="dashed"
          >
            下载导入模板
          </Button>
        )
      },
      exportDataRender: () => {
        return (
          <Button
            icon={<DownloadOutlined />}
            onClick={onExportData}
            disabled={exportLoading}
            loading={exportLoading}
            type="dashed"
          >
            导出
          </Button>
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            {record.prodType !== 'PRODUCT_PACKAGE' && (
              <SActionBtn onClick={() => handleSearchPrice(record)}>查看价格</SActionBtn>
            )}
          </STableActions>
        )
      },
      priceRangeRender({ name, form }) {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <InputNumber
              style={{ width: '50%' }}
              placeholder="请输入"
              onChange={v => {
               setMinPrice(v)
                listRef?.current?.getSearch().setFieldsValue({
                  ['channelPriceStartWith']: v,
                })
              }}
            />
            <span> ~ </span>
            <InputNumber
              style={{ width: '50%' }}
              placeholder="请输入"
              min={minPrice}
              onChange={v => {
                console.log(v, 'v1111111')
                listRef?.current?.getSearch().setFieldsValue({
                  ['channelPriceEndWith']: v,
                })
              }}
            />
          </div>
        )
      },
      productRender: ({ name, form }) => {
        return (
          <DebounceSelect
            allowClear
            label={'上架产品'}
            isCommon={false}
            style={{ width: '100%' }}
            onChange={v => {
              form.setFieldsValue({ [name]: v })
            }}
            fixedParams={{ prodType: 'PRODUCT_PACKAGE', enabled: null }}
            fetchOptions={getProductCommonPage}
            fieldNames={{ label: 'prodName', value: 'id' }}
          />
        )
      },
      modelRender: ({ name, form }) => {
        return (
          <DebounceSelect
            label={'型号'}
            allowClear
            isCommon={false}
            style={{ width: '100%' }}
            onChange={v => {
              form.setFieldsValue({ [name]: v })
            }}
            fixedParams={{ enabled: null }}
            nameKey="model"
            fetchOptions={findSpuModelPage}
            fieldNames={{ label: 'model', value: 'model' }}
            resDataIsArray={true}
          />
        )
      },
      formatRender: ({ name, form }) => {
        return (
          <DebounceSelect
            allowClear
            label={'规格'}
            isCommon={false}
            style={{ width: '100%' }}
            onChange={v => {
              form.setFieldsValue({ [name]: v })
            }}
            fixedParams={{ enabled: null }}
            nameKey="format"
            fetchOptions={findSpuFormatPage}
            fieldNames={{ label: 'format', value: 'format' }}
            resDataIsArray={true}
          />
        )
      },
    },
    scroll: { x: 'max-content', y: 'calc(100vh - 310px)' },
  }
  const onSubmit = () => {
    editRef.current?.onFinish()
  }
  const onSubmitOk = values => {
    generalStandardBatchAdd({
      generalStandard: values,
      skuQuery: {
        ...searchParams,
        ids: chooseDiabled ? [] : selectedRowKeys, //id列表,
      },
    })
      .then((res: any) => {
        message.success(res.message || '操作成功')
        listRef.current?.reload()
        onCancel()
      })
      .catch(() => {
        setGeneralStandardLoading(false)
      })
      .finally(() => {
        setGeneralStandardLoading(false)
      })
  }
  const onCancel = () => {
    setGeneralStandardOpen(false)
  }
  return (
    <div className={styles.treeTable}>
      <div className={styles.leftMenu}>
        {/* 左侧树形选择 */}
        <SAside
          treeData={treeData}
          onSelect={onChangeType}
          title={''}
          treeType="tree"
          defaultSelectedKeys={['0']}
          // active={state.categoryCode}
          fieldNames={{ title: 'cateName', key: 'id' }}
          header={false}
          dropItems={false}
        />
      </div>
      {/* 右侧表格数据 */}
      <div className={styles.rightTable}>
        <SLowcodeList
          ref={listRef}
          searchMode="group"
          config={config}
          {...extensions}
          rowSelectedTotal={chooseDiabled ? totalCount : ''}
        />
      </div>
      {openNotComPriceModal && (
        <NotCombinatePriceModal
          open={openNotComPriceModal}
          setOpen={setOpenNotComPriceModal}
          skuId={chooseSkuId}
          orgList={orgList}
          skuSourceType={skuSourceType}
        />
      )}
      {openComPriceModal && (
        <CombinatePriceModal
          open={openComPriceModal}
          setOpen={setOpenComPriceModal}
          skuId={chooseSkuId}
          orgList={orgList}
        />
      )}
      <SDrawerOrModal
        title={'添加通项标配'}
        width={600}
        open={generalStandardOpen}
        onOk={onSubmit}
        loading={generalStandardLoading}
        onCancel={onCancel}
      >
        {generalStandardOpen && (
          <AddOrEditStandard
            record={{}}
            ref={editRef}
            fn={onSubmitOk}
            setLoading={(btnLoading: boolean) => setGeneralStandardLoading(btnLoading)}
          />
        )}
        {previewObj.open && (
          <ProductDetailDrawerSpuSku
            previewObj={previewObj}
            setPreviewObj={setPreviewObj}
          />
        )}
      </SDrawerOrModal>
    </div>
  )
}
